import { STORE_MAPPING } from '@/Scripts/constants.js';

const storeLangUrlPart = function (lang) {
  const language = document.documentElement.lang;
  if (language === 'nb-NO') {
    return 'butikker';
  } else if (language === 'de-DE') {
    return 'norrona-shops';
  } else if (language === 'sv-SE') {
    return 'norrona-butiker';
  } else if (language === 'fr-FR') {
    return 'norrona-magasins';
  }

  return 'stores';
};

export const getOpenToday = function (storeOpeningObject) {
  const weekdayNumber = new Date().getDay();
  let validItem = null;
  const list = storeOpeningObject.filter(x => x.Date === null);
  list.forEach(item => {
    if (item.Days === 0) {
      validItem = item;
    } else if (item.Days === 1 && weekdayNumber >= 1 && weekdayNumber <= 6) {
      validItem = item;
    } else if (item.Days >= 2 && item.Days === weekdayNumber + 1) {
      validItem = item;
    }
  });
  return validItem;
};

export const storePageUrl = function (key, lang) {
  if (!key) {
    return null;
  }
  const storepart = STORE_MAPPING[key];
  const url = `/${lang}/${storeLangUrlPart(lang)}/${storepart}`;
  return url;
};
